export const channelSavedSuccess = {
  title: '更新完了',
};
